export default __webpack_public_path__ + "static/media/Background_00223.e9546f31.png";